// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dd-selector[data-v-120ad4a2]{position:relative}.dd-selector .dd-selector__bg[data-v-120ad4a2]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:10;background-color:transparent}@media (max-width:959px){.dd-selector .dd-selector__bg[data-v-120ad4a2]{display:none}}@media (min-width:960px){.dd-selector:not(.dd-selector--show) .dd-selector__bg[data-v-120ad4a2]{pointer-events:none}}", ""]);
// Exports
module.exports = exports;
